import TutorialList from "components/Tutorial/TutorialList";
import TutorialContents from "./TutorialContents";
import "./index.scss";

function View({
  title,
  slideRef,
  missions,
  currentMission,
  missionIdx,
  totalMissionNum,
  completedMissionIdx,
  onClickCloseBtn,
  onClickMenuBtn,
  onClickNextBtn,
  onClickPrevBtn,
}) {
  const isPrevEnabled = missionIdx > 0;
  const isNextEnabled = missionIdx + 1 < totalMissionNum && missionIdx <= completedMissionIdx;

  return (
    <>
      <aside className="tutorial">
        <header className="tutorial__header">
          <button className="tutorial__menu-list-btn" onClick={onClickMenuBtn} />
          <p className="tutorial__header__title">{title}</p>
          <button onClick={onClickCloseBtn} className={`tutorial__close-btn tutorial__close-btn--true`}></button>
        </header>
        <div className="tutorial__body" ref={slideRef}>
          <TutorialContents mission={currentMission} />
        </div>
        <div className="tutorial__footer">
          <button className={`slide-prev-btn ${isPrevEnabled ? "on" : "off"}`} onClick={onClickPrevBtn}>
            <span className="icon" />
          </button>
          <span className="tutorial__current">
            {missionIdx + 1} / {totalMissionNum}
          </span>
          <button className={`slide-next-btn ${isNextEnabled ? "on" : "off"}`} onClick={onClickNextBtn}>
            <span className="icon" />
          </button>
        </div>
        <TutorialList title={title} missions={missions} />
      </aside>
    </>
  );
}

export default View;
